import React from "react";
import {BarChartPro} from "@mui/x-charts-pro";
import CCMuiChart from "./CCMuiChart";

class CCBarChart extends CCMuiChart {
    static ATTR_MAP: [string, string][] = [
        ["AxisHighlight", "axisHighlight"],
        ["BarLabel", "barLabel"],
        ["BorderRadius", "borderRadius"],
        ["BrushConfig", "brushConfig"],
        ["Colors", "colors"],
        ["Dataset", "dataset"],
        ["DisableAxisListener", "disableAxisListener"],
        ["ExperimentalFeatures", "experimentalFeatures"],
        ["Grid", "grid"],
        ["Height", "height"],
        ["HiddenItems", "hiddenItems"],
        ["HideLegend", "hideLegend"],
        ["HighlightedAxis", "highlightedAxis"],
        ["HighlightedItem", "highlightedItem"],
        ["Id", "id"],
        ["Layout", "layout"],
        ["LoadingText", "loadingText"],
        ["Margin", "margin"],
        ["onAxisClick", "onAxisClick"],
        ["onHiddenItemsChange", "onHiddenItemsChange"],
        ["onHighlightChange", "onHighlightChange"],
        ["onHighlightedAxisChange", "onHighlightedAxisChange"],
        ["onItemClick", "onItemClick"],
        ["onZoomChange", "onZoomChange"],
        ["ShowToolbar", "showToolbar"],
        ["SkipAnimation", "skipAnimation"],
        ["SlotProps", "slotProps"],
        ["Slots", "slots"],
        ["Width", "width"],
        ["ZoomData", "zoomData"],
        ["ZoomInteractionConfig", "zoomInteractionConfig"],
    ];

    renderChart(chartProps: any): React.ReactNode {
        return <BarChartPro {...chartProps} sx={this.props.sx} />;
    }
}

export default CCBarChart;
